import palette from "../palette";

export default {
  root: {
    color: palette.text.primary,
    "&$selected": {
      backgroundColor: "#0F2533",
      color: palette.text.primary
    }
  }
};
